export const Base_URL = process.env.REACT_APP_BASE_URL;

export const Base_URL_AiScore = process.env.REACT_APP_AI_SCORE_URL;

export const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL;
